export const PridobitevRacunov = {
  methods: {
    GetSeznamRacunov (prenosniParam) {
      let param = ['sap=' + prenosniParam.prenesenIzbranSap]
      this.clientAgent.postWsRequest(
        this,
        'stranka/racun/info',
        param,
        prenosniParam,
        'SetSeznamRacunov',
        'ErrSeznamRacunov')
    },
    SetSeznamRacunov (podatki, prenosniParam) {
      let seznamRacunov = []
      seznamRacunov = podatki.racuni
      let vseOdprtePostavke = 0
      let zapadlePostavke = 0
      let danes = new Date()
      let dd = danes.getDate()
      let mm = danes.getMonth() + 1
      let yyyy = danes.getFullYear()
      if (dd < 10) {
        dd = '0' + dd
      }
      if (mm < 10) {
        mm = '0' + mm
      }
      let danasnjiDatum = yyyy + '-' + mm + '-' + dd
      let IzpisZadnjihTrehRacunov = []
      for (let i = 0; i < seznamRacunov.length; i++) {
        if (!Array.isArray(seznamRacunov[i].KLJUC)) {
          let datumPoravnave = seznamRacunov[i].DATUMPPORAVNAVE
          if (datumPoravnave !== null) {
            let formatDatumPoravnave = seznamRacunov[i].DATUMPPORAVNAVE.slice(0, 10)
            let razrez = formatDatumPoravnave.slice(6, 10) +
              '-' + formatDatumPoravnave.slice(3, 5) +
              '-' + formatDatumPoravnave.slice(0, 2)
            vseOdprtePostavke += Number(seznamRacunov[i].SALDO)
            if (seznamRacunov[i].SALDO <= 0 && danasnjiDatum > razrez) {
              zapadlePostavke = (zapadlePostavke + Number(seznamRacunov[i].SALDO))
            }
          }
          let racun = seznamRacunov[i]
          racun.KLJUC = seznamRacunov[i].KLJUC
          if (!Array.isArray(seznamRacunov[i].DATDOK)) {
            racun.DATDOKC_izpis = seznamRacunov[i].DATDOK
          } else {
            racun.DATDOKC_izpis = 0
          }
          if (seznamRacunov[i].SALDO <= 0) {
            racun.placano_izpis = 'DA'
          } else {
            racun.placano_izpis = 'NE'
          }
          if (seznamRacunov[i].DATDOK !== null) {
            racun.leto = seznamRacunov[i].DATDOK.slice(0, 4)
            IzpisZadnjihTrehRacunov.push(racun)
          }
        }
      }
      vseOdprtePostavke = vseOdprtePostavke.toFixed(2)
      zapadlePostavke = zapadlePostavke.toFixed(2)
      let seznamSamoRacunov = []
      for (let i = 0; i < IzpisZadnjihTrehRacunov.length; i++) {
        if (IzpisZadnjihTrehRacunov[i].OBROK === '0') {
          seznamSamoRacunov.push(IzpisZadnjihTrehRacunov[i])
        }
      }
      seznamRacunov = seznamSamoRacunov.slice(0, 4)
      let vmesnik = prenosniParam.vmesnik
      let nalaganje = false
      vmesnik.PrenosniPodatkiRacuni(prenosniParam, seznamRacunov, vseOdprtePostavke, zapadlePostavke, nalaganje)
    },
    ErrSeznamRacunov (podatki) {
      this.ShowWarningMessage(podatki)
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/globalne_funkcije/Racuni/PridobitevRacunov.js